export default __webpack_public_path__ + "static/media/certificate-badge-circle.8582f03b.svg";